import React from "react"
import { BenchmarkTemplateProps } from "../../interfaces"
import BenchmarkTemplateManagerConfig from "./BenchmarkTemplateManagerConfig"
import { MetricName } from "../MetricsSelect/interfaces"

const BenchmarkTemplateManager = (props: BenchmarkTemplateProps) => {
	const { metricName } = props

	const Template = BenchmarkTemplateManagerConfig[metricName as MetricName]

	if (!Template) {
		return null
	}

	return <Template {...props} />
}

export default BenchmarkTemplateManager
